import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser, selectUserRole } from "../../../store/slices/authSlice";
import { BsBell } from "react-icons/bs";
import { IoIosArrowDown } from "react-icons/io";
import headeravatar from "../../../assets/images/header-avatar.png";

export default function AdminNavbar() {
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUser);
  const userRole = useSelector(selectUserRole);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    navigate("/logout");
  };

  const handleSettings = () => {
    navigate("/admin/settings");
    setShowDropdown(false);
  };

  const handleViewClientSide = () => {
    navigate("/admin/view-as");
    setShowDropdown(false);
  };

  const userName = user
    ? `${user.firstName} ${user.lastName}`
    : "Admin User";
  const userEmail = user?.email || "admin@legacy72.com";
  const roleLabel = userRole?.name || "Admin";

  return (
    <header className="topbar">
      <div className="topbar-inner">
        <div className="search">
          <input type="text" placeholder="Search admin..." />
        </div>

        <div className="user-info">
          <img className="header-avatar" src={headeravatar} alt="Admin Avatar" />

          <div className="user-text">
            <div className="hello">
              Hello, <strong>{userName}</strong>
              <span className="role-badge-inline">({roleLabel})</span>
            </div>
            <div className="email">{userEmail}</div>
          </div>

          <div className="navbar-dropdown-wrapper" ref={dropdownRef}>
            <span
              className="dropdown"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <IoIosArrowDown size={24} />
            </span>

            {showDropdown && (
              <div className="navbar-dropdown-menu">
                <button onClick={handleSettings} className="dropdown-item">
                  Settings
                </button>
                <button onClick={handleViewClientSide} className="dropdown-item">
                  View Client Side
                </button>
                <div className="dropdown-divider"></div>
                <button onClick={handleLogout} className="dropdown-item danger">
                  Logout
                </button>
              </div>
            )}
          </div>

          <span className="bell">
            <BsBell size={24} />
          </span>
        </div>
      </div>
    </header>
  );
}
